<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('hr_employees.penalty')"
    />

    <div class="row">
      <div class="col-6">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @input="search()"
              type="search"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <button
          type="button"
          @click="/*addTicketResolutions()*/ openModal = true"
          class="btn btn-light float-end mb-4"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>
    <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
      <thead>
        <tr
          class="text-light text-center"
          style="background-color: #2a3042 !important"
        >
          <th scope="col">#</th>
          <th scope="col">{{ $t("hr_employees.penalty_id") }}</th>
          <th scope="col">{{ $t("hr_employees.name") }}</th>
          <th scope="col">{{ $t("hr_employees.penalty_amount") }}</th>
          <th scope="col">{{ $t("hr_employees.month") }}</th>
          <th scope="col">{{ $t("hr_employees.year") }}</th>
          <th scope="col">{{ $t("hr_employees.description") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(penalty, indx) in penalties"
          :key="penalty.id"
          class="text-center"
        >
          <td>{{ (currentPage - 1) * perPage + indx + 1 }}</td>
          <td>{{ penalty.emp_id }}</td>
          <td>
            {{ this.$i18n.locale === "en" ? penalty.name : penalty.name_ar }}
          </td>
          <td>{{ Number(penalty.amount).toLocaleString() }}</td>
          <td>{{ penalty.month }}</td>
          <td>{{ penalty.year }}</td>
          <td v-html="penalty.description"></td>
        </tr>
      </tbody>
    </table>
    <div class="d-flex justify-content-center mt-4">
      <BPagination
        :total-rows="rows"
        :per-page="perPage"
        v-model="currentPage"
      />
    </div>
  </Layout>
  <BModal hide-footer v-model="openModal" :title="$t('popups.add_penalty')">
    <form @submit.prevent="AddPenalty">
      <div class="mb-3">
        <label for="name" class="form-label">{{
          $t("hr_employees.name")
        }}</label
        ><br />
        <AutoComplete
          :suggestions="items"
          @complete="SearchEmp($event)"
          optionLabel="name"
          v-model="form.name"
          :complete-on-focus="true"
          appendTo="self"
          required
        />
      </div>
      <div class="mb-3">
        <label for="amount" class="form-label">{{
          $t("hr_employees.penalty_amount")
        }}</label
        ><br />
        <currency-input
          class="form-control"
          id="amount"
          v-model="form.amount"
          required
        ></currency-input>
      </div>
      <div class="mb-3">
        <label for="date" class="form-label">{{
          $t("hr_employees.penalty_date")
        }}</label>
        <input
          type="month"
          class="form-control"
          id="date"
          v-model="form.date"
          required
        />
      </div>
      <div class="mb-3">
        <label for="description" class="form-label">{{
          $t("hr_employees.description")
        }}</label>
        <ckeditor
          :editor="editor"
          v-model="form.report"
          :config="editorConfig"
        ></ckeditor>
        <div v-if="errors.report" class="text-danger">
          {{ errors.report }}
        </div>
      </div>
      <div class="d-flex justify-content-end gap-4">
        <button class="btn btn-secondary" @click="openModal = false">
          {{ $t("popups.colse") }}
        </button>
        <button type="submit" class="btn btn-primary">
          {{ $t("popups.add") }}
        </button>
      </div>
    </form>
  </BModal>
</template>
<script>
import PageHeader from "@/components/page-header";
import Layout from "../../../layouts/main.vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-vue";
export default {
  components: {
    Layout,
    PageHeader,
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      penalties: [],
      searchModel: "",
      openModal: false,
      rows: 0,
      perPage: 10,
      currentPage: 1,
      items: [],
      content: [],
      form: {
        name: "",
        amount: "",
        date: "",
        description: "",
      },
      editor: ClassicEditor,
      editorConfig: {
        // The configuration of the editor.
      },
      errors: {},
    };
  },
  watch: {
    currentPage() {
      this.search();
    },
    searchModel() {
      if (this.searchModel.length > 0) this.search();
      else {
        this.currentPage = 1; // Reset to first page on search
        this.search();
      }
    },
  },
  methods: {
    search() {
      this.http
        .post("penalty/search", {
          query: this.searchModel,
          limit: this.perPage,
          page: this.currentPage,
        })
        .then((response) => {
          console.log("Search response:", response.data);
          this.penalties = response.data;
          this.rows = response.total;
          console.log("search hhhhh", this.penalties);
        });
    },
    AddPenalty() {
      this.errors = {}; // reset
      if (!this.form.report || this.form.report.trim() === "") {
        this.errors.report =
          this.$i18n.locale == "en"
            ? "This field is required"
            : "هذا الحقل مطلوب";
        return;
      }
      this.http.post("penalty/add-penalty", this.form).then(() => {
        this.form = {
          name: "",
          amount: "",
          date: "",
          description: "",
        };
        this.openModal = false;
        this.search();
      });
    },
    SearchEmp(event) {
      const qry = event.query.toLowerCase();
      this.items = qry
        ? this.content.filter((emp) => emp.name.toLowerCase().includes(qry))
        : [...this.content];
    },
    GetEmployees() {
      this.http.get("penalty/search").then((res) => {
        this.content = res.data;
      });
    },
  },
  created() {
    this.GetEmployees();
    this.search();
  },
  // mounted() {
  //     this.search();
  //     this.GetEmployees();
  // }
};
</script>
<style lang=""></style>
